import * as actionType from "../../../constants";
import * as commonData from "../../../Common";

export const getAllStatus = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  dispatch({ type: actionType.STATUS_LOADING });
  try {
    const response = await fetch(`${url}system/status/list`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.ALL_STATUS_LIST,
        payload: rdata.data.all_records,
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};
